<template>
    <div class="row pt-2">
        <div class="col-12 mt-4 p-lr-0-sm">
            <div class="right-sidebar-small-header pl-3 pr-3 pt-2 pb-2 flex-se">
                <button type="button" class="btn btn-element" @click="selectedMenu = 'myInfo'" :class="{'active-btn': selectedMenu == 'myInfo'}"><i class="uis uis-info-circle mr-2"></i>Info</button>
                <button type="button" class="btn btn-element" @click="selectedMenu = 'mySecurity'" :class="{'active-btn': selectedMenu == 'mySecurity'}"><i class="uis uis-padlock mr-2"></i>Security</button>
            </div>
        </div>
    </div>

    <div class="row information-profile" v-if="selectedMenu == 'myInfo'">
        <div class="col-12 mt-3 p-lr-0-sm">
            <div class="fast-actions-block pl-3 pr-3 pl-3 pr-3 pt-2 pb-2 flex-se max-h-230vh" ref="profileMenuInfoBlock">
                <div class="content-crds-messages-scroll pos-relative pt-4">
                    <div class="btn small-form-btn bar-code fs-10 mb-2 pointer pos-absolute p-right-1r mt-1r" @click="myInfo.editMode = true">
                        <i class="uis uis-edit-alt fs-11"></i>
                    </div>
                    <label>Gender</label>
                    <select class="multisteps-form__input form-control mb-3" v-model="myInfo.gender" :disabled="!myInfo.editMode">
                        <option value="0" selected disabled>Choose Gender</option>
                        <option value="1">Male</option>
                        <option value="2">Female</option>
                    </select>
                    <label>Name</label>
                    <input class="multisteps-form__input form-control mb-3" type="text" placeholder="Your Name" v-model="myInfo.name" :disabled="!myInfo.editMode">
                    <label>Surname</label>
                    <input class="multisteps-form__input form-control mb-3" type="text" placeholder="Your Surname" v-model="myInfo.surname" :disabled="!myInfo.editMode">
                    <label>Country</label>
                    <select v-if="myInfo.editMode" class="multisteps-form__input form-control mb-3" v-model="myInfo.country_id">
                        <option value="" selected disabled hidden>Your Country</option>
                    </select>
                    <input v-else class="multisteps-form__input form-control mb-3" type="text" placeholder="Your Country" :value="myInfo.country_id" disabled>
                    <label>City</label>
                    <select v-if="myInfo.editMode" class="multisteps-form__input form-control mb-3" v-model="myInfo.city_id">
                        <option value="" selected disabled hidden>Your City</option>
                    </select>
                    <input v-else class="multisteps-form__input form-control mb-3" type="text" placeholder="Your City" :value="myInfo.city_id" disabled>
                    <label>Address</label>
                    <input class="multisteps-form__input form-control mb-3" type="text" placeholder="Your Address" v-model="myInfo.address" :disabled="!myInfo.editMode">
                    <label>Postcode</label>
                    <input class="multisteps-form__input form-control mb-3" type="text" placeholder="Postcode / Zip" v-model="myInfo.postCode" :disabled="!myInfo.editMode">
                    <div class="dis-flex flex-m" v-if="myInfo.editMode">
                        <button class="btn button-create-atrb-btn" type="button" title="Save Changes">Save</button>
                        <button class="btn button-create-atrb-btn close-form ml-auto plr-3" type="button" title="Close" @click="cancelDataEdit()"><i class="uis uis-multiply text-white"></i></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row security-profile" v-if="selectedMenu == 'mySecurity'">
        <div class="col-12 mt-3 p-lr-0-sm">
            <div class="fast-actions-block pl-3 pr-3 pl-3 pr-3 pt-2 pb-2 flex-se">
                Security Block
                <label>Email</label>
                <input class="multisteps-form__input form-control mb-3" type="text" placeholder="Your Email">
                <label>Phone</label>
                <input class="multisteps-form__input form-control mb-3" type="text" placeholder="Mobile Phone">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            selectedMenu: 'myInfo',
            myInfo: {
                editMode: false,
                photo_url: '',
                name: '',
                surname: '',
                country_id: null,
                city_id: null,
                address: '',
                postCode: '',
            }
        }
    },
    methods: {
        cancelDataEdit() {
            this.getMyDataFromGlobal()
            this.myInfo.editMode = false
        },
        getMyDataFromGlobal() {
            this.myInfo.name = this.$store.state.myData.profileData.name
            this.myInfo.surname = this.$store.state.myData.profileData.surname
            this.myInfo.gender = this.$store.state.myData.profileData.gender
            this.myInfo.photo_url = this.$store.state.myData.profileData.photo_url
            this.myInfo.country_id = this.$store.state.myData.profileData.worker.country_id
            this.myInfo.city_id = this.$store.state.myData.profileData.worker.city_id
            this.myInfo.address = this.$store.state.myData.profileData.worker.address
            this.myInfo.postCode = this.$store.state.myData.profileData.worker.postCode
        }
    },
    mounted() {
        this.getMyDataFromGlobal()
    }
}
</script>

<style>

</style>